<template>
  <fragment>
    <div style="margin-left: auto; margin-right: auto">
      <div
        class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
        role="alert"
        v-show="closeModal"
      >
        <i class="material-icons pr-2" style="font-size: 3em">info</i>
        <p style="text-align: center">PÁGINA EM MANUTENÇÃO!</p>
        <br />
        <p style="text-align: center">
          Estamos trabalhando para resolvermos o mais breve possível.
        </p>
        <br />
        <p style="text-align: center">
          Para solicitações, entre em contato conosco através dos canais abaixo:
        </p>
        <p style="text-align: center">- Telefone: (31) 3249-1666</p>
        <p style="text-align: center">- WhatsApp: (31) 3249-1666</p>
        <p style="text-align: center">- E-mail: relacionamento@cdlbh.com.br</p>
        <p style="text-align: center">- Chat: cdlbh.com.br</p>
        <p style="text-align: center">
          Nosso horário de funcionamento é das 8h às 19h, de segunda à sexta e
          de 08h às 14h aos sábados e feriados.
        </p>
        <Botao
          title="Voltar"
          link="/"
          class="btn btn-outline-dark sepia mt-2 fit-content ml-2"
          style="background-color: green; color: white"
          >VOLTAR
        </Botao>
      </div>
    </div>

    <div class="col-md-9" v-show="statusManutencao">
      <form class="form_padrao pt-2" action @submit.prevent="abrirChamado">
        <div class="form-row">
          <div class="form-group flutuante col-md-6">
            <input
              type="text"
              name="nomeOperador"
              id="nomeOperador"
              required
              v-model="operador.solicitante"
            />
            <label for="nomeOperador">Nome do Solicitante</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <the-mask
              type="text"
              name="cpf"
              id="cpf"
              v-model="operador.cpf"
              required
              :mask="['###.###.###-##']"
            />
            <label for="cpf">CPF</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <the-mask
              type="text"
              name="telefoneContato"
              id="telefoneContato"
              v-model="operador.telefone"
              required
              :mask="['(##) ####-####', '(##) #####-####']"
            />
            <label for="telefoneContato">Telefone de Contato</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <input
              type="text"
              name="emailOperador"
              id="emailOperador"
              v-model="operador.email"
              required
            />
            <label for="emailOperador">E-mail</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="enderecoDemanda"
              id="enderecoDemanda"
              v-model="operador.enderecoDemanda"
              required
            />
            <label for="enderecoDemanda">Endereço da demanda</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <textarea
              type="text"
              name="demanda"
              id="demanda"
              v-model="operador.demanda"
              required
            ></textarea>
            <label for="demanda">Demanda</label>
          </div>
        </div>

        <div class="form-row">
          <div
            class="form-group col-md-3 d-flex flex-row justify-content-end align-items-end"
          >
            <button
              type="submit"
              class="btn btn-verde p-0 fit-content"
              :disabled="loading"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Enviando</span>
              <span v-else>enviar Solicitação</span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-3 d-none d-md-block pt-2">
      <img
        src="http://via.placeholder.com/300x450?text=publicidade%20CDL"
        class="img-fluid"
        alt="publicidade"
      />
    </div>
  </fragment>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Botao from "@/components/botoes/Botao";

export default {
  name: "OperadoresSPC",
  components: {
    TheMask,
    Botao,
  },
  data() {
    return {
      meios: [
        { nome: "Internet" },
        { nome: "Microterminal (TCC)" },
        { nome: "Impressora de Cheque" },
        { nome: "PDV" },
        { nome: "Arquivo" },
        { nome: "URA Nacional" },
        { nome: "Host a Host / VT100" },
        { nome: "Web Service" },
        { nome: "Mobile" },
      ],
      produto: {
        nome: "SOS Soluções",
        id: "SOS solucoes",
      },
      loading: false,
      operador: {
        solicitante: null,
        cpf: null,
        telefone: null,
        email: null,
        enderecoDemanda: null,
        demanda: null,
      },
      statusManutencao: false,
      closeModal: true,
      breadcrumb: [
        {
          nome: "SOS Soluções",
          id: "SOS solucoes",
        },
      ],
    };
  },
  methods: {
    abrirChamado() {
      this.loading = true;
      this.$http
        .post("/api/Ssm/RegistrarChamadoServicos", {
          idItemDeCatalogo: 193,
          motivo: `Solicitante: ${this.operador.solicitante}-Email: ${this.operador.email}-Telefone: ${this.operador.telefone}-CPF: ${this.operador.cpf}-Endereço: ${this.operador.enderecoDemanda}-Demanda: ${this.operador.demanda}`,
        })
        .then((response) => {
          this.loading = false;
          this.$toast.open({
            message: response.data.message,
            type: "success",
          });
          this.operador = {};
        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message: "Erro no envio da solicitação, tente novamente.",
            type: "error",
          });
        });
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
hr {
  color: #888 !important;
  border-color: rgb(206, 206, 206) !important;
}
</style>
<style lang="scss">
.p-datepicker-title select {
  color: black;
  font-size: 0.8rem;
  width: auto !important;
}
.p-datepicker-title {
  display: flex !important;
}

.listBox {
  border: 0px !important;
  div {
    ul {
      background: #e5e6f1 !important;
    }
  }
}
</style>
